import { render } from "./DashboardTab.vue?vue&type=template&id=73c792bb&scoped=true"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"

import "./DashboardTab.vue?vue&type=style&index=0&id=73c792bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c792bb"]])

export default __exports__